import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plan-comparision-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './plan-comparision-table.component.html',
  styleUrl: './plan-comparision-table.component.scss'
})
export class PlanComparisionTableComponent {
  @Input() data: any[] = [];

  getIcon(value: string): string {
    switch (value) {
      case 'check':
        return '/assets/img/circle-check.png';
      case 'cross':
        return '/assets/img/circle-cross.png';
      case 'info':
        return '/assets/img/circle-information.png';
      default:
        return '';
    }
  }
  
  // Verifica si la fila incluye una característica "A demanda"
  isOnDemandFeature(description: string): boolean {
    return description.includes('(A demanda)');
  }
}